export default {
  namespaced: true,
  vxg_camera: {
    id_vxg: "ID External",
    name: "Name",
    rec_mode: "Rec Mode",
    live_stream: "Live Stream",
    recording_stream: "Recording Stream",
    access_token_watch: "Access Token Watch",
    access_token_all: "Access Token All",
    streaming: "Streaming",
    timezone: "Timezone",
    update_from_vxg: "Update cameras from API",
    select_multiple: "Select Multiple",
    delete_vxg_sbo: "Delete VaaS and SBO",
    delete_sbo: "Delete in SBO",
    removed: "Removed",
    removed_cameras: "Removed cameras",
    rec_limit: "Recording days",
    location: "Location" || "Locations",
    stream: "Stream",
    recording: "Recording",
    main_transmission: "Live video transmission",
    live_broadcast: "Recorded video transmission",
    transmission: "Transmission configuration",
    video_encoder: "Video encoder",
    vbr_quality: "VBR quality",
    vbr: "VBR",
    events_enabled: "Events Enabled",
    register_type: "Register Type",
    bitrate: "Bitrate",
    update_stream: "Update stream configuration",
    ip: "IP",
    fps: "Stream FPS",
    resolution_stream: "Stream Resolution",
    format_stream: "Stream Format",
    camera_not_connected: "Camera is not connected at this moment.",
  },
};
